import { Fragment, useState } from "react";
import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { sentenceCase } from "change-case-all";
import { Avatar, Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";
import { FaRegUser } from "react-icons/fa6";
import {
  brandDetailsObject,
  objectFromResponse,
} from "../../brand components/brand details components/brandDetailObject";
import BrandDetailsDialog from "../../campaign components/brand details components/BrandDetailsDialog";
import Categorize from "./Categorize";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple};
  color: ${colors.purple};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  brandList,
  loading,
  component,
  setPage,
  setSearchKey,
  filterBy,
  setFilterBy,
}) {
  const navigate = useNavigate();

  const [brandDetails, setBrandDetails] = useState({
    data: brandDetailsObject,
    state: false,
  });

  function handleNavigation(brand) {
    if (component === "users") {
      navigate(pages.usersList.route + brand.brand_id);
    }

    if (component === "campaign") {
      navigate(pages.superAdminBrandCampaigns.route + brand.brand_id);
    }
  }

  function handleBrandDetails(brandData) {
    setBrandDetails({
      data: objectFromResponse(brandData),
      state: true,
      component: "connection",
    });
  }

  var columns = [
    {
      name: "",
      label: "",
    },

    {
      name: "brand_name",
      label: "Brand Name",
    },

    {
      name: "about",
      label: "About Brand",
    },

    {
      name: "business_entity_type_name",
      label: "Partner Type",
    },

    {
      name: "created_date",
      label: "Date Joined",
    },

    {
      name: "total_users",
      label: "Total User",
    },

    {
      name: "credit_details",
      label: "Total Credits",
    },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "") {
      return (
        <Avatar
          sx={{ cursor: "pointer" }}
          onClick={() => handleBrandDetails(row)}
          src={
            row.logo
              ? row.logo
              : "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a2d75083a653441c8541c4de8c0e3088/1754635285823_default_logo.webp"
          }
        />
      );
    }

    if (col.name === "credit_details") {
      return value?.coins;
    }

    if (col.name === "business_entity_type_name") {
      return sentenceCase(value?.split("_")[0]);
    }
    if (col.name === "about") {
      return value.length > 15 ? value.substr(0, 15) + "...." : value;
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip onClick={() => handleNavigation(row)} title="View">
            <Icon>
              {component === "campaign" ? (
                <CgEye style={{ height: "20px", width: "20px" }} />
              ) : (
                <FaRegUser style={{ height: "20px", width: "20px" }} />
              )}
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Fragment>
      <Grid container spacing={8}>
        <Grid size={12} />
        <Grid size={12}>
          <MuiTable
            loading={loading}
            components={[
              <ToolBar
                setPage={setPage}
                setSearchKey={setSearchKey}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
              />,
            ]}
            columns={columns}
            renderCell={renderCell}
            data={brandList}
          />
        </Grid>
      </Grid>
      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );
}

export function ToolBar({ setPage, setSearchKey, filterBy, setFilterBy }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />

        <Categorize
          filterBy={filterBy}
          setFilterBy={setFilterBy}
          setPage={setPage}
        />
      </div>
    </div>
  );
}
